
import {
  defineComponent, Ref, ref,
} from 'vue';
import { useRouter } from 'vue-router';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
  },
  emits: ['hide'],
  setup(props, { emit }) {
    const router = useRouter();

    const navigation: Ref<HTMLElement | null> = ref(null);
    const showNavigation: Ref<boolean> = ref(false);

    function goToAddContacts() {
      emit('hide');
      router.push('add');
    }

    return {
      navigation,
      showNavigation,
      goToAddContacts,
      emit,
    };
  },
});
